import React from 'react'
import Button from 'react-toolbox/lib/button/Button';

export const PanelButton = props => {
    let style = {padding: "0px", width: "100%"};

    return (
        <div className={props.nameClass}>
            <Button
                style={style}
                icon={props.icon}
                disabled={props.disabled}
                onClick={props.onClick} raised
            >
                {props.children}
            </Button>
        </div>
    )
};


// WEBPACK FOOTER //
// ./src/components/Map/AdminAppBar/PanelButton.js